import { createSlice } from "@reduxjs/toolkit";
import { fetchContactSupportList, fetchcontactSupportTableColumnNames } from "./thunk";

const initialState = {
  tableColumnNames: [],
  contactSupportList: [],
  loading: false,
  headerLoading: false,
  error: null,
};

const contactSupportSlice = createSlice({
  name: "contactSupport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    // Fetch Chat Report Table Column Names
    .addCase(fetchcontactSupportTableColumnNames.pending, (state) => {
        state.headerLoading = true;
        state.error = null;
    })
    .addCase(fetchcontactSupportTableColumnNames.fulfilled, (state, action) => {
        state.headerLoading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchcontactSupportTableColumnNames.rejected, (state, action) => {
        state.headerLoading = false;
        state.error = action.payload;
    })


    .addCase(fetchContactSupportList.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchContactSupportList.fulfilled, (state, action) => {
        state.loading = false;
        state.contactSupportList = action.payload;
    })
    .addCase(fetchContactSupportList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })
  },
});

export default contactSupportSlice.reducer;
